import { Button } from '@mui/material';
import ConfirmationModal from 'components/modal/ConfirmationModal';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

export const approveAction = service => {
    return props => {
        // eslint-disable-next-line no-unused-vars
        const { component: MenuItem, onClick, params, ...restProps } = props;
        const { id } = params;
        let confirmationText = <>Do you really want to approve?</>;

        const value = 'approve';
        const label = 'Approve';

        const { enqueueSnackbar } = useSnackbar();

        const [openModal, setOpenModal] = useState(false);

        const handleOpenConfirmationModal = e => {
            e.preventDefault();
            e.stopPropagation();
            setOpenModal(true);
        };

        const handleCloseConfirmationModal = () => {
            setOpenModal(false);
        };

        const handleApprove = async () => {
            try {
                await service.approve(id);
                enqueueSnackbar(' Approved', { variant: 'success' });
                onClick(value);
            } catch (error) {
                enqueueSnackbar('Unable to approve', { variant: 'error' });
            } finally {
                onClick(value);
                handleCloseConfirmationModal();
            }
        };

        return (
            <>
                <ConfirmationModal
                    onClose={handleCloseConfirmationModal}
                    isOpen={openModal}
                    title="Confirmation"
                    renderActions={() => (
                        <>
                            <Button
                                onClick={() => handleCloseConfirmationModal()}
                                variant="outlined"
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleApprove}
                                color="primary"
                                variant="contained"
                            >
                                Approve
                            </Button>
                        </>
                    )}
                >
                    {confirmationText}
                </ConfirmationModal>
                <MenuItem
                    key={value}
                    value={value}
                    label={label}
                    onClick={handleOpenConfirmationModal}
                    {...restProps}
                >
                    {label}
                </MenuItem>
            </>
        );
    };
};
